import styled from 'styled-components';

export const FormWrapper = styled.form`
  border-radius: 3px;
  box-shadow: 0 2px 0px rgba(34, 34, 34, 0.1), 0 2px 0px rgba(34, 34, 34, 0.1);
  margin-top: ${p => p.theme.spacing(8)};
  margin-bottom: ${p => p.theme.spacing(8)};
  padding: ${p => (p.padding ? p.padding : p.theme.spacing(2))};
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.1);

  @media (${p => p.theme.mq.desktop}) {
    padding: ${p => (p.padding ? p.padding : p.theme.spacing(12))};
  }
`;

export const FormBoxWrapper = styled.div``;



// WEBPACK FOOTER //
// ./src/components/Form/styles.js